import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Home as HomeIcon, Truck, UtensilsCrossed } from 'lucide-react';
import { services } from '../mock';

const WhyChooseUs = () => {
  return (
    <section className="py-32 px-6 bg-secondary/20">
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-5xl md:text-6xl font-serif font-normal text-primary mb-24 text-center tracking-wide">
          Miért válassz minket?
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {services.map((service, index) => {
            const IconComponent = {
              'star': Star,
              'home': HomeIcon,
              'truck': Truck,
              'chef-hat': UtensilsCrossed
            }[service.icon];

            return (
              <div key={index} className="text-center">
                <div className="flex justify-center mb-8">
                  <div className="w-16 h-16 border border-border flex items-center justify-center rotate-45">
                    <IconComponent className="w-6 h-6 text-foreground -rotate-45" />
                  </div>
                </div>
                <h3 className="text-lg font-serif font-medium text-foreground mb-4 tracking-wide uppercase">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-sm font-light leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
